import cashPackages from './components/cash_package/reducer'

const cashpackage = { cashPackages }

export {
  cashpackage
}